import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import {
  Grid,
  Header,
  Button,
} from 'semantic-ui-react';
import Timestamp from './Timestamp';
import CTOSResult from './CTOSResult';

const BookingCreditCheck = ({
  auth,
  customerData,
  data,
}, { store }) => (
    customerData &&
    customerData.customer &&
    customerData.customer.customerCreditReport ?
      <Grid className="creditCheckGrid">
        {
          customerData.customer.customerCreditReportID !== '' ? (
            <Grid centered>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={14} computer={16}>
                  <CTOSResult
                    customerData={customerData}
                    customerDataID={customerData.customer.id}
                    data={data}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button
                    content="Run credit check"
                    color="blue"
                    onClick={() => {
                      store.dispatch(push(`/bookings/${data.id}/customers/${customerData.customer.id}/credit_check/`));
                    }}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : (
            <Grid.Row className="credit-check-booking">
              <Grid.Column className="box-wrap" mobile={16} tablet={16} computer={9}>
                <Grid verticalAlign="middle" divided className="box" columns="equal">
                  <Grid.Row stretched>
                    <Grid.Column className="score" textAlign="left" mobile={7} tablet={4} computer={4}>
                      <p>
                        CTOS Score:
                      </p>
                      <Header as="h2" content="-" style={{ marginTop: 0 }} />
                    </Grid.Column>
                    <Grid.Column className="score" textAlign="left" mobile={9} tablet={4} computer={4}>
                      <p>
                        DSR:
                      </p>
                      <Header as="h2" content="-" style={{ marginTop: 0 }} />
                    </Grid.Column>
                    <Grid.Column className="last-column" textAlign="center" mobile={16} tablet={8} computer={8}>
                      <Grid verticalAlign="middle" className="box">
                        <Grid.Row stretched>
                          <Grid.Column className="time" mobile={16} tablet={8} computer={7} textAlign="center">
                            {
                              customerData.customer.customerCreditReport.createdAt !== null ?
                                <Timestamp
                                  timestamp={customerData.customer.customerCreditReport.createdAt}
                                />
                              : null
                            }
                          </Grid.Column>
                          <Grid.Column className="button-check" mobile={16} tablet={8} computer={9} textAlign="center">
                            <Button
                              type="button"
                              size="small"
                              color="blue"
                              onClick={() => {
                                store.dispatch(push(`/bookings/${data.id}/customers/${customerData.customer.id}/credit_check/`));
                              }}
                            >
                              Run Credit check
                            </Button>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          )
        }
      </Grid> : null
  );

BookingCreditCheck.propTypes = {
  auth: PropTypes.shape({
    isBranchLeader: PropTypes.bool,
    isHeadquarters: PropTypes.bool,
    isSuperAdmin: PropTypes.bool,
  }),
  customerData: PropTypes.shape({
    customer: PropTypes.object,
  }),
  data: PropTypes.shape({
    id: PropTypes.string,
  }),
};

BookingCreditCheck.contextTypes = {
  store: PropTypes.object,
};

export default BookingCreditCheck;



// WEBPACK FOOTER //
// ./src/components/BookingCreditCheck.jsx